import { render, staticRenderFns } from "./EditCoach.vue?vue&type=template&id=68bcebeb&scoped=true&"
import script from "./EditCoach.vue?vue&type=script&lang=js&"
export * from "./EditCoach.vue?vue&type=script&lang=js&"
import style0 from "./EditCoach.vue?vue&type=style&index=0&id=68bcebeb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bcebeb",
  null
  
)

export default component.exports